import { supplierDashboardApi } from "../../api";

const SupplierDashboardService = {
  /**
   * 📊 Obtiene las estadísticas del dashboard de proveedores.
   * GET /api/dashboard/suppliers/stats
   */
  getStats: async () => {
    try {
      const response = await supplierDashboardApi.fetchCustom("/stats");
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default SupplierDashboardService;
